// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.family.CreatePatientFamilyInsuranceRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePatientFamilyInsuranceRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Copy Insurance is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	copyInsurance!: boolean;

	@GandalfConstantDecorator(constants.PolicyHolderRelationship)
	@GandalfValidator({ notNull: { message: 'Relation to Insured is required' } })
	@GandalfProperty({ designType: constants.PolicyHolderRelationship, isRequired: true })
	relationshipToInsured!: constants.PolicyHolderRelationship;

}
